import React, { useState } from "react";
import { Box, Typography, Modal, IconButton, Divider, Grid, Paper, Chip, Collapse, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OrderTable from "./OrderTable";

const OrderView = ({ openEdit, handleEditPop, dataById }) => {
  const [showAddressDetails, setShowAddressDetails] = useState(true);
  const billing_address_info = dataById[0]?.billing_address_info;
  const shipping_address_info = dataById[0]?.shipping_address_info;
  const device_details = dataById[0]?.device_details || [];

  const renderAddressInfo = (label, addressInfo) => (
    <Box sx={{ mb: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, color: "#333" }}>
        {label}
      </Typography>
      <Grid container spacing={0.5}>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#666" }}>
            Name:
          </Typography>
          <Typography sx={{ fontSize: "0.85rem" }}>
            {addressInfo?.fname} {addressInfo?.lname}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#666" }}>
            Phone:
          </Typography>
          <Typography sx={{ fontSize: "0.85rem" }}>{addressInfo?.phone}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#666" }}>
            Email:
          </Typography>
          <Typography sx={{ fontSize: "0.85rem" }}>{addressInfo?.email}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#666" }}>
            Country/State:
          </Typography>
          <Typography sx={{ fontSize: "0.85rem" }}>
            {addressInfo?.country}, {addressInfo?.state}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#666" }}>
            Address:
          </Typography>
          <Typography sx={{ fontSize: "0.85rem" }}>{addressInfo?.address_1}</Typography>
          {addressInfo?.address_2 && <Typography sx={{ fontSize: "0.85rem" }}>{addressInfo?.address_2}</Typography>}
        </Grid>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#666" }}>
            City/Postal:
          </Typography>
          <Typography sx={{ fontSize: "0.85rem" }}>
            {addressInfo?.city}, {addressInfo?.postal}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );

  const renderDeviceDetails = () => {
    const deviceColumns = [
      { id: 'unique_order', label: 'Device ID', minWidth: 120 },
      { id: 'product_name', label: 'Product Name', minWidth: 150 },
      { id: 'module_names', label: 'Modules', minWidth: 150 },
      { id: 'device_status', label: 'Status', minWidth: 100 },
    ];

    return (
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5, color: "#333" }}>
          Device Details
        </Typography>
        <TableContainer sx={{ overflowX: "auto" }}>
          <Table stickyHeader aria-label="device details table">
            <TableHead>
              <TableRow>
                {deviceColumns.map((column) => (
                  <TableCell
                    key={column.id}
                    style={{ minWidth: column.minWidth, whiteSpace: "nowrap", fontWeight: 600 }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {device_details?.length > 0 ? (
                device_details.map((device, index) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
                      {device?.unique_order}
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
                      {device?.product_name}
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
                      {device?.module_names}
                    </TableCell>
                    <TableCell style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
                      <Chip
                        label={device?.device_status === 0 ? "Pending" : "Active"}
                        size="small"
                        color={device?.device_status === 0 ? "default" : "success"}
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={deviceColumns.length} align="center">
                    No device details available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  const renderTotals = (totals) => (
    <Box>
      {totals.map((item, index) => (
        <React.Fragment key={index}>
          {item.label === "Total Amount" && (
            <Divider sx={{ my: 1.5, borderColor: "#ddd" }} />
          )}
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, alignItems: "center" }}>
            <Typography sx={{ fontWeight: item.label === "Total Amount" ? 700 : 600, fontSize: "0.95rem" }}>
              {item.label}:
            </Typography>
            <Typography sx={{ fontWeight: item.label === "Total Amount" ? 700 : 500, fontSize: "0.95rem" }}>
              {item.value}
            </Typography>
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );

  console.log("Order Data:", dataById[0]); // Debugging log
  return (
    <Modal open={openEdit} onClose={handleEditPop} aria-labelledby="order-details-modal">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95%", sm: "90%", md: "85%" },
          maxHeight: "90vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          overflowY: "auto",
          borderRadius: 2,
        }}
      >
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Order Details
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "#666", mt: 0.5 }}>
              BP{dataById[0]?.id} | Order Date:{" "}
              {new Date(dataById[0]?.created).toLocaleDateString()}
            </Typography>
          </Box>
          <IconButton onClick={handleEditPop} sx={{ color: "#666" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ mb: 3 }} />

        {/* Billing & Shipping Toggle */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#333" }}>
            Address Details
          </Typography>
          <IconButton
            onClick={() => setShowAddressDetails(!showAddressDetails)}
            sx={{
              transform: showAddressDetails ? "rotate(0deg)" : "rotate(-90deg)",
              transition: "transform 0.3s",
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        </Box>

        {/* Billing & Shipping Info - Collapsible */}
        <Collapse in={showAddressDetails} timeout="auto">
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} md={6}>
              {renderAddressInfo("Billing Address", billing_address_info)}
            </Grid>
            <Grid item xs={12} md={6}>
              {renderAddressInfo("Shipping Address", shipping_address_info)}
            </Grid>
          </Grid>
          <Divider sx={{ mb: 2 }} />
        </Collapse>

        <Grid container spacing={3}>
          {/* Products & Devices Section */}
          <Grid item xs={12} md={7}>
            {/* Products */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5, color: "#333" }}>
                Products
              </Typography>
              <Box sx={{ overflowX: "auto" }}>
                <OrderTable data={dataById[0]?.items} />
              </Box>
            </Box>

            {/* Device Details */}
            {device_details.length > 0 && renderDeviceDetails()}
          </Grid>

          {/* Right Side: Pricing & Address Info */}
          <Grid item xs={12} md={5}>
            {/* Order Summary Box */}
            <Paper sx={{ p: 2, bgcolor: "#fafafa", border: "1px solid #e0e0e0" }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: "#333" }}>
                Order Summary
              </Typography>
              {renderTotals([
                { label: "Shipping Method", value: dataById[0]?.shipping_method },
                { label: "Product Price", value: `$${dataById[0]?.product_total_price}` },
                { label: "Shipping Fee", value: `$${dataById[0]?.Shipping_fee}` },
                ...(dataById[0]?.discounted_amount > 0
                  ? [{ label: "Discount", value: `- $${dataById[0]?.discounted_amount}` }]
                  : []),
                { label: "Total Amount", value: `$${dataById[0]?.total_amount}` },
              ])}
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default OrderView;
